<template>
  <div
    class="currency-amount-input"
    :class="{ 'currency-amount-input--compact': size === 'compact' }">
    <span class="currency-amount-input__prefix">R$</span>
    <input
      ref="input"
      type="text"
      inputmode="numeric"
      class="currency-amount-input__field"
      :value="displayValue"
      :placeholder="min.toString()"
      @input="onInput"
      @keyup.enter="$emit('enter')"
      @blur="onBlur">
    <span class="currency-amount-input__suffix">,00</span>
  </div>
</template>

<script>
export default {
  name: 'CurrencyAmountInput',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 999999
    },
    size: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      displayValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        const num = this.toNumber(val)
        this.displayValue = num !== null && !isNaN(num) ? String(Math.floor(num)) : ''
      }
    }
  },
  methods: {
    toNumber (val) {
      if (val === null || val === undefined || val === '') return null
      const n = Number(val)
      return isNaN(n) ? null : n
    },
    onInput (event) {
      const raw = event.target.value.replace(/\D/g, '')
      if (raw === '') {
        this.displayValue = ''
        this.$emit('input', null)
        return
      }
      const num = parseInt(raw, 10)
      this.displayValue = raw
      this.$emit('input', isNaN(num) ? null : num)
    },
    onBlur () {
      const num = this.toNumber(this.displayValue)
      if (num === null || this.displayValue === '') {
        const fallback = Math.max(this.min, 0)
        this.displayValue = String(fallback)
        this.$emit('input', fallback)
        return
      }
      const clamped = Math.min(this.max, Math.max(this.min, Math.floor(num)))
      this.displayValue = String(clamped)
      if (clamped !== num) this.$emit('input', clamped)
    },
    focus () {
      this.$refs.input && this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/financial';

.currency-amount-input {
  display: inline-flex;
  align-items: stretch;
  min-width: 0;
  max-width: 11rem;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid $financial-border;
  background: #fff;
}

.currency-amount-input__prefix,
.currency-amount-input__suffix {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.45rem;
  background: $financial-bg-muted;
  color: $financial-text-secondary;
  font-size: 0.875rem;
  font-weight: 500;
  flex-shrink: 0;
}

.currency-amount-input__prefix {
  border-right: 1px solid $financial-border;
}

.currency-amount-input__suffix {
  border-left: 1px solid $financial-border;
  color: $financial-text-secondary;
}

.currency-amount-input__field {
  flex: 1 1 auto;
  min-width: 2.5rem;
  border: none;
  padding: 0.28rem 0.45rem;
  font-size: 0.875rem;
  font-weight: 750;
  color: $financial-text;
  text-align: center;
  background: #fff;

  &::placeholder {
    color: #c0c0c0;
  }

  &:focus {
    outline: none;
  }
}

.currency-amount-input--compact .currency-amount-input__prefix,
.currency-amount-input--compact .currency-amount-input__suffix,
.currency-amount-input--compact .currency-amount-input__field {
  padding: 0.22rem 0.35rem;
  font-size: 0.8rem;
}

.currency-amount-input--compact .currency-amount-input__field {
  height: 30px;
  min-width: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/CurrencyAmountInput.vue